export class UrlParam {
  Subscriber: string;
  HotelId: number;
  Language: string;
  Language4Digit: string;
}
